import removeUser from './removeUser'

export default removeUser
